<template>
  <home></home>
</template>

<script>
import store from "./_store";
import Home from "./_components/home.vue";

/**
 * @module ManageJob
 * @description manage job module
 */
export default {
  /**
   * @memberof module:ManageJob
   * @namespace components
   * @description components of manage job module
   */
  components: {
    Home,
  },
  created() {
    const STORE_KEY = "$_error_logs";
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
};
</script>
